var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container-fluid"},[_c('third-party-service-form',{attrs:{"loading":_vm.loading,"thirdPartyServiceData":_vm.thirdPartyService,"formErrors":_vm.formErrors},on:{"thirdPartyServiceSubmitted":_vm.handleSubmit,"formChanged":() => (_vm.alertLeave = true)}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }